import React, {createContext, useContext} from 'react';

const SlidePreviewCaptureContext = createContext(false);

export function SlidePreviewCaptureProvider({children}: {children: React.ReactNode}): JSX.Element {
    return <SlidePreviewCaptureContext.Provider value>{children}</SlidePreviewCaptureContext.Provider>;
}

export function useSlidePreviewCapture(): boolean {
    return useContext(SlidePreviewCaptureContext);
}
